module.exports = __webpack_public_path__ + "static/portal-69862a1203fc864d70104c0a0efe58d0.jpg";